import React from 'react';
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';

export interface UnsavedChangesConfirmationModalProps {
    show: boolean;
    onCancelChanges: () => void;
    onContinueEditing: () => void;
    message?: string;
}

const DEFAULT_MESSAGE =
    "You've made updates that haven't been applied. Canceling will discard your changes permanently. Do you want to keep them?";

export const UnsavedChangesConfirmationModal: React.FC<UnsavedChangesConfirmationModalProps> = ({
    show,
    onCancelChanges,
    onContinueEditing,
    message = DEFAULT_MESSAGE
}) => {
    return (
        <Modal
            data-testid="unsaved-changes-confirmation-modal"
            footer={{
                options: [
                    {
                        action: onCancelChanges,
                        label: 'Cancel Changes',
                        buttonStyle: 'tertiary'
                    }
                ],
                primary: {
                    action: onContinueEditing,
                    label: 'Continue Editing',
                    customIdentifiers: {
                        primaryButton: {
                            dataTestId: 'continue-editing-button'
                        }
                    }
                }
            }}
            header={
                <Typography variant="h4" color="base.color.blue.700" data-testid="unsaved-changes-confirmation-title">
                    Warning: Changes Will Be Lost
                </Typography>
            }
            id="unsaved-changes-confirmation-modal"
            onHide={onContinueEditing}
            size="small"
            show={show}
        >
            <Typography variant="body-md" data-testid="unsaved-changes-confirmation-text">
                {message}
            </Typography>
        </Modal>
    );
};

export default UnsavedChangesConfirmationModal;
